import axios from "axios";
import { API_GET_PRODUCT_SUB_CATEGORIES_BY_CATEGORY_DATA, API_GET_PRODUCT_SUB_CATEGORIES_DATA, API_INSERT_PRODUCT_SUB_CATEGORY_DATA, API_TOGGLE_PRODUCT_SUB_CATEGORY_DATA, API_UPDATE_PRODUCT_SUB_CATEGORY_DATA } from ".";

export const getProductSubCategoriesList = async (func, config) => {
    return axios.get(API_GET_PRODUCT_SUB_CATEGORIES_DATA, config).then(res => func(res.data.data));
}

export const getProductSubCategoriesByCatList = async (func, config, id) => {
    return axios.get(API_GET_PRODUCT_SUB_CATEGORIES_BY_CATEGORY_DATA+`?product_category_id=${id}`, config).then(res => func(res.data.data));
}

export const insertProductSubCategoryData = async (data, config) => {
    return axios.post(API_INSERT_PRODUCT_SUB_CATEGORY_DATA, data, config).then((res) => res.data);
};

export const updateProductSubCategoryData = async (data, config) => {
    return axios.post(API_UPDATE_PRODUCT_SUB_CATEGORY_DATA, data, config).then((res) => res.data);
};

export const toggleProductSubCategoryData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_PRODUCT_SUB_CATEGORY_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};